/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRefresh = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M10.364 4c4.665 0 8.492 3.29 8.632 7.747L19 12v1.585l1.293-1.292 1.414 1.414L18 17.414l-3.707-3.707 1.414-1.414L17 13.585V12c0-3.419-2.935-6-6.636-6C6.853 6 4 8.906 4 12.5S6.853 19 10.364 19a6.243 6.243 0 0 0 3.764-1.258l.228-.18 1.272 1.544A8.25 8.25 0 0 1 10.364 21C5.74 21 2 17.19 2 12.5 2 7.81 5.74 4 10.364 4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRefresh as Refresh };
